import React from 'react'
import Img from 'gatsby-image'
import ArrowButton from './arrowButton'
import { Default, Mobile } from '../../media-queries'
import MDText from './MDText'

const GraphicCard = ({
  title,
  image,
  imageStyle,
  text,
  route,
  children,
  style,
  scale = true,
}) =>
  scale ? (
    <div className="card">
      <Default>
        <div
          style={{
            ...cardStyle,
            padding: '1.5rem 1.5rem 1rem 1.5rem',
            display: 'flex',
            flexDirection: 'row',
            fontSize: '13px',
            lineHeight: 1.35,
            ...style,
          }}
        >
          {image && <Img sizes={image.sizes} style={{ ...imgStyle, ...imageStyle }} />}
          <div style={{ marginLeft: '1em', fontWeight: 300 }}>
            <div style={{ ...titleStyle, fontSize: '15px' }}>{title}</div>
            <div>
              <MDText source={text} />
            </div>
            {children}
            {route && (
              <ArrowButton
                route={route}
                style={{ paddingTop: '1rem', marginBottom: 0 }}
                text="More"
              />
            )}
          </div>
        </div>
      </Default>
      <Mobile>
        <div style={{ ...cardStyle, ...style }}>
          {image && <Img sizes={image.sizes} style={{ ...imgStyle, ...imageStyle }} />}
          <div style={titleStyle}>{title}</div>
          <div style={textStyle}>
            <MDText source={text} />
          </div>
          {children}
          {route && (
            <ArrowButton
              route={route}
              style={{ paddingTop: '1rem' }}
              text="More"
            />
          )}
        </div>
      </Mobile>
    </div>
  ) : (
    <div className="card" style={{ ...cardStyle, ...style }}>
      {image && <Img sizes={image.sizes} style={{ ...imgStyle, ...imageStyle }} />}
      <div style={titleStyle}>{title}</div>
      <div style={textStyle}>
        <MDText source={text} />
      </div>
      {children}
      {route && (
        <ArrowButton route={route} style={{ paddingTop: '1rem' }} text="More" />
      )}
    </div>
  )

export default GraphicCard

const cardStyle = {
  fontFamily: '"Libre Franklin", "sans serif"',
  padding: '2rem',
  background: 'white',
}

const titleStyle = {
  fontSize: '16px',
  fontWeight: 'bold',
  marginBottom: '.75rem',
  textAlign: 'left',
}

const textStyle = {
  fontSize: '14px',
  fontWeight: 300,
}

const imgStyle = {
  height: '80px',
  width: '80px',
  marginLeft: '-.75rem',
  marginTop: '-.75rem',
  marginBottom: '1rem',
}



// WEBPACK FOOTER //
// ./src/components/shared/graphicCard.js